import { combineReducers } from "redux";
import { PageReducer } from "./reducers";

 const rootReducer=combineReducers({Page:PageReducer});

export default rootReducer;
